import { useEffect, useState } from "react";
import { Loader2, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { PageHeader } from "@/components/admin/PageHeader";
import { EntityForm } from "@/components/admin/EntityForm";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const fields = [
  { name: "logo_path", label: "Logo Masjid (untuk kop surat PDF & website)", type: "image", folder: "logo", full: true },
  { name: "name", label: "Nama Masjid", required: true },
  { name: "established_year", label: "Tahun Berdiri" },
  { name: "address", label: "Alamat Lengkap", type: "textarea", required: true },
  { name: "phone", label: "No. Telepon / WA" },
  { name: "email", label: "Email" },
  { name: "description", label: "Deskripsi Singkat", type: "textarea" },
  { name: "vision", label: "Visi", type: "textarea" },
  { name: "mission", label: "Misi", type: "textarea" },
  { name: "bank_name", label: "Nama Bank" },
  { name: "bank_account", label: "No. Rekening Infaq" },
  { name: "bank_holder", label: "Atas Nama", full: true },
];

export default function ProfilMasjid() {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);
  const [pw, setPw] = useState({ old_password: "", new_password: "" });
  const [pwSaving, setPwSaving] = useState(false);

  useEffect(() => {
    api.get("/profile").then((r) => setForm(r.data)).catch((e) => toast.error(errMsg(e)));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.put("/profile", form);
      setForm(data);
      toast.success("Profil masjid disimpan");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setSaving(false);
    }
  };

  const changePw = async (e) => {
    e.preventDefault();
    setPwSaving(true);
    try {
      await api.post("/auth/change-password", pw);
      toast.success("Kata sandi berhasil diubah");
      setPw({ old_password: "", new_password: "" });
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setPwSaving(false);
    }
  };

  if (!form) return <p className="text-slate-500">Memuat...</p>;

  return (
    <div data-testid="admin-profile-page">
      <PageHeader title="Profil Masjid" subtitle="Informasi yang ditampilkan di website publik" />
      <form onSubmit={save} className="rounded-3xl bg-white border border-emerald-900/10 p-6 space-y-6">
        <EntityForm fields={fields} form={form} setForm={setForm} prefix="profile" />
        <div className="flex justify-end">
          <Button type="submit" disabled={saving} className="rounded-full emerald-bg hover:bg-[#145c48]" data-testid="profile-save-btn">
            {saving ? <Loader2 className="animate-spin" size={16} /> : "Simpan Profil"}
          </Button>
        </div>
      </form>
      <form onSubmit={changePw} className="mt-6 rounded-3xl bg-white border border-emerald-900/10 p-6 max-w-xl">
        <h3 className="font-semibold text-emerald-950 flex items-center gap-2"><KeyRound size={16} /> Ganti Kata Sandi Admin</h3>
        <div className="grid sm:grid-cols-2 gap-4 mt-4">
          <div className="space-y-1.5">
            <Label htmlFor="old_pw">Kata Sandi Lama</Label>
            <Input id="old_pw" type="password" value={pw.old_password} onChange={(e) => setPw({ ...pw, old_password: e.target.value })} required data-testid="pw-old-input" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="new_pw">Kata Sandi Baru</Label>
            <Input id="new_pw" type="password" value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} required minLength={6} data-testid="pw-new-input" />
          </div>
        </div>
        <div className="flex justify-end mt-4">
          <Button type="submit" variant="outline" disabled={pwSaving} className="rounded-full" data-testid="pw-save-btn">
            {pwSaving ? <Loader2 className="animate-spin" size={16} /> : "Ubah Kata Sandi"}
          </Button>
        </div>
      </form>
    </div>
  );
}
